import { Component, inject, PLATFORM_ID, signal } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { AuthService } from '../../../../services/auth-service';
import { MobileInput } from '../register-component/mobile-input/mobile-input';
import { CustomValidators } from '../../../../validators/custom-validators';

@Component({
  selector: 'app-forgot-password-mobile-input',
  standalone: true,
  imports: [CommonModule, RouterModule, ReactiveFormsModule, MobileInput],
  templateUrl: './forgot-password-mobile-input.html',
  styleUrls: ['./forgot-password-mobile-input.scss'],
})
export class ForgotPasswordMobileInput {
  private authService = inject(AuthService);
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);

  apiError = signal('');
  loading = signal(false);

  mobileForm = new FormGroup({
    phoneNumber: new FormControl<any>('', {
      validators: [CustomValidators.mobileNumber()],
    }),
  });

  onSubmit() {
    if (this.mobileForm.invalid) {
      this.mobileForm.markAllAsTouched();
      return;
    }
    this.apiError.set('');
    this.loading.set(true);
    const mobileControlValue = this.mobileForm.value.phoneNumber as { dialCode: string; number: string } | null;
    const fullMobileNumber = (mobileControlValue?.dialCode || '') + (mobileControlValue?.number || '');

    this.authService
      .requestPasswordReset(fullMobileNumber, { method: 'SMS' })
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe({
        next: () => {
          if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('forgotUsername', fullMobileNumber);
            localStorage.setItem('otpMethod', 'SMS');
            this.router.navigate(['/forgot-password/otp-verify']);
          }
        },
        error: (err) => {
          console.error('Failed to send OTP:', err);
          this.apiError.set(err.messageEn || 'An unexpected error occurred while sending OTP. Please try again later.');
        },
      });
  }

  isFieldInvalid(fieldName: string): boolean {
    const control = this.mobileForm.get(fieldName);
    return !!(control && control.invalid && control.touched);
  }

  hasError(fieldName: string, errorName: string): boolean {
    return !!(this.mobileForm.get(fieldName)?.hasError(errorName) && this.mobileForm.get(fieldName)?.touched);
  }
}
